import { lazy } from 'react'

export default lazy(
    () => 
    import('./NDRViewB2B') 
)